export default function() {
  return /(iPad|iPhone|iPod|Android|Blackberry|Nokia|BB|Phone|iOS)/g.test(navigator.userAgent) ||
      window.innerWidth <= 768;
}
